import { Fragment } from 'react';
import Image from 'next/future/image';
import { oneLine } from 'common-tags';

import { Container, NextLink } from '@/atoms';
import { Button, Content01, TwoColumn } from '@/molecules';

import { removeBaseURL } from '@/lib/utils';

import type { FunctionComponent } from 'react';
import type { TypeCardAdvantageProps } from './types';

/**
 * CardAdvantage
 */
export const CardAdvantage: FunctionComponent<TypeCardAdvantageProps> = ({
  image,
  filas,
  imagePositionDesktop,
  imagePositionMobile = 'top',
  imageMaxWidth = 350,
  showImageMobile = true,
  textOrientation,
  className = '',
  isDark = false,
}: TypeCardAdvantageProps) => (
  <TwoColumn
    {...(imagePositionDesktop === 'right' && {
      reverse: true,
    })}
    gap="gap-6 md:gap-[94px]"
    className={`items-center !py-9 ${className}
    ${showImageMobile ? 'min-h-[461px]' : 'md:min-h-[461px]'} `}
  >
    <TwoColumn.Left
      className={`flex flex-wrap max-md:justify-center 
      ${!showImageMobile ? 'max-md:hidden' : ''} 
      ${imagePositionMobile === 'top' ? 'max-md:!order-first' : ''} 
      ${imagePositionDesktop === 'left' ? 'md:justify-end' : ''}`}
    >
      {image && (
        <Image
          src={image.sourceUrl}
          alt={image.altText ?? ''}
          width={image.mediaDetails.width}
          height={image.mediaDetails.height}
          className="object-cover"
          {...(imageMaxWidth && {
            style: {
              width: imageMaxWidth,
            },
          })}
          draggable={false}
        />
      )}
    </TwoColumn.Left>

    <TwoColumn.Rigth
      className={`${
        imagePositionDesktop === 'right' ? 'ml-auto' : ''
      } max-md:items-center md:max-w-[422px]`}
    >
      <Container className="gap-5" padding="p-0">
        {filas?.map((fila, index) => (
          <Fragment key={index}>
            <Content01
              pretitle={fila.pretitle}
              title={fila.title}
              subtitle={fila.subtitle}
              isDark={isDark}
              className={`text-left md:text-${textOrientation}`}
            >
              {fila.description}
            </Content01>
            {fila.button?.label && fila.button?.link && (
              <NextLink
                href={removeBaseURL(fila.button?.link.url ?? '')}
                passHref
              >
                <Button
                  label={fila.button.label}
                  negative={fila.button.negativo}
                  as="a"
                  style={fila.button?.style ?? 'primary'}
                  className={oneLine`
                    mt-6 min-w-full md:min-w-fit
                    ${textOrientation === 'right' ? 'ml-auto' : 'mr-auto'}
                  `}
                />
              </NextLink>
            )}
          </Fragment>
        ))}
      </Container>
    </TwoColumn.Rigth>
  </TwoColumn>
);
